/* 03 出汁入り自家製麺（2026-10-02）：麺の配合札。画面に入ったら材料を一つずつ刷り重ねる（1回だけ。動きを減らす設定では最初から出ている）。 */
(() => {
  const init = (el) => {
    if (el.dataset.haigoOn) return;
    el.dataset.haigoOn = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    el.classList.add('is-armed');
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      el.classList.add('is-in');
    }), { threshold: .5, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  };
  const run = () => document.querySelectorAll('[data-kz-haigo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
